export default __webpack_public_path__ + "static/media/MC_Systems.08a32af0.png";